import axios from "axios";

export const authService = {
   /** Resource */

   createResourceService: (body) => axios.post("/resource", body, { auth: true }),

   editResourceService: (id, body) => axios.patch(`/resource/${id}`, body, { auth: true }),

   getResourceService: (data) =>  axios.get("/resource", { auth: true, params: { ...data } }),

   getResourceByIdService: (id) => axios.get(`/resource/${id}`, { auth: true }),

   deleteResourceService: (id) => axios.delete(`/resource/${id}`, { auth: true }),

   /** End */

   /** Resource Documents */

   uploadService: (file, id) => axios.post(`/resource/${id}/documents`, { ...file }, { auth: true }),

   editService: ({ id, dockId, file }) => axios.patch(`/resource/${id}/documents/${dockId}`, { ...file }, { auth: true }),

   getFilesService: (id) => axios.get(`/resource/${id}/documents`, { auth: true }),

   deleteFilesService: (adminId, id) => axios.delete(`/resource/${adminId}/documents/${id}`, { auth: true }),

   /** End */

   editResourceAccessService: (id, body) => axios.patch(`/resource/${id}/accesses`, body, { auth: true }),

   getResourceAccessService: (id) => axios.get(`/resource/${id}/accesses`, { auth: true }),

   /** End */

};
